import { render, staticRenderFns } from "./StoreAdmins.vue?vue&type=template&id=15cdb53a&scoped=true&"
import script from "./StoreAdmins.vue?vue&type=script&lang=js&"
export * from "./StoreAdmins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cdb53a",
  null
  
)

export default component.exports